
<c-contract-editor
    :title    = "$t('contract.zus.fulltitle')"
    :unit-data = "unitData"
    @store    = "onStore"
    @edit     = "onEdit"
    @start    = "onStart"
    @end      = "onEnde"
>
     <template v-slot:additional>
        <v-row class="no-frame">
            <v-col class="no-frame pr-1 col-6">
                <f-currency-field-rw
                    :label        = "$t('contract.zus.costsMainAudit')"
                    :readonly     = "readonly"
                    v-model       = "unitData.mainAudit"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-1">
                <f-currency-field-rw
                    :label        = "$t('contract.zus.costIntermediateAudit')"
                    :readonly     = "readonly"
                    v-model       = "unitData.intermediateAudit"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame pr-1">
                <f-currency-field-rw
                    :label        = "$t('contract.zus.costAuditAfterChange')"
                    :readonly     = "readonly"
                    v-model       = "unitData.auditAfterChange"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-1">
                <f-currency-field-rw
                    :label        = "$t('contract.zus.costAuditAfterDefects')"
                    :readonly     = "readonly"
                    v-model       = "unitData.auditAfterDefects"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>
    </template>
 </c-contract-editor>
